function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as ScanditSDK from "scandit-sdk";
import OperationQueue from "./operation-queue";

var _default = function _default() {
  var _this = this;

  _defineProperty(this, "operationQueue", new OperationQueue());

  _defineProperty(this, "isInitialized", false);

  _defineProperty(this, "initialize", function (scannerContainer, props) {
    ScanditSDK.BarcodePicker.create(scannerContainer, {
      accessCamera: props.accessCamera,
      camera: props.camera,
      cameraSettings: props.cameraSettings,
      cameraType: props.cameraType,
      enableCameraSwitcher: props.enableCameraSwitcher,
      enablePinchToZoom: props.enablePinchToZoom,
      enableTapToFocus: props.enableTapToFocus,
      enableTorchToggle: props.enableTorchToggle,
      guiStyle: props.guiStyle,
      laserArea: props.laserArea,
      playSoundOnScan: props.playSoundOnScan,
      scanningPaused: props.paused,
      scanSettings: props.scanSettings,
      singleImageModeSettings: props.singleImageModeSettings,
      targetScanningFPS: props.targetScanningFPS,
      vibrateOnScan: props.vibrateOnScan,
      videoFit: props.videoFit,
      visible: props.visible,
      viewfinderArea: props.viewfinderArea
    }).then(function (picker) {
      picker.on("ready", function () {
        props.onReady != null && props.onReady();
      });
      picker.on("scan", function (result) {
        return props.onScan != null && props.onScan(result);
      });
      picker.on("scanError", function (result) {
        return props.onScanError != null && props.onScanError(result);
      });
      picker.on("processFrame", function (result) {
        return props.onProcessFrame != null && props.onProcessFrame(result);
      });
      picker.on("submitFrame", function (result) {
        return props.onSubmitFrame != null && props.onSubmitFrame(result);
      });
      _this.picker = picker;

      _this.operationQueue.execute();
    });
    _this.isInitialized = true;
  });

  _defineProperty(this, "destroy", function () {
    if (_this.picker != null) {
      _this.picker.destroy();
    }
  });

  _defineProperty(this, "addToQueue", function (f) {
    if (_this.isInitialized == true) {
      _this.operationQueue.add(f);
    }
  });

  _defineProperty(this, "update", function (prevProps, props) {
    _this.setScanSettings(prevProps, props);

    _this.setScanning(prevProps, props);

    _this.setAccessCamera(prevProps, props);

    _this.setActiveCamera(prevProps, props);

    _this.setCameraSettings(prevProps, props);

    _this.setEnableCameraSwitcher(prevProps, props);

    _this.setEnableTorchToggle(prevProps, props);

    _this.setEnablePinchToZoom(prevProps, props);

    _this.setEnableTapToFocus(prevProps, props);

    _this.setGuiStyle(prevProps, props);

    _this.setLaserArea(prevProps, props);

    _this.setMirrorImage(prevProps, props);

    _this.setPlaySoundOnScanEnabled(prevProps, props);

    _this.setVibrateOnScanEnabled(prevProps, props);

    _this.setTargetScanningFPS(prevProps, props);

    _this.setVideoFit(prevProps, props);

    _this.setVisible(prevProps, props);

    _this.setViewfinderArea(prevProps, props);

    _this.setZoom(prevProps, props);

    if (_this.picker != null) {
      _this.operationQueue.execute();
    }
  });

  _defineProperty(this, "setScanSettings", function (prevProps, props) {
    var shouldSet = prevProps == null || JSON.stringify(prevProps.scanSettings) != JSON.stringify(props.scanSettings);

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.applyScanSettings(props.scanSettings));
      });
    }
  });

  _defineProperty(this, "setScanning", function (prevProps, props) {
    if (_this.picker != null) {
      if (props.paused && !_this.picker.isScanningPaused()) {
        // should pause?
        _this.addToQueue(function () {
          return Promise.resolve(_this.picker.pauseScanning(!props.accessCamera));
        });
      } else if (!props.paused && _this.picker.isScanningPaused()) {
        // should resume?
        _this.addToQueue(function () {
          return _this.picker.resumeScanning();
        });
      }
    }
  });

  _defineProperty(this, "setAccessCamera", function (prevProps, props) {
    var shouldSet = (prevProps == null || prevProps.accessCamera != props.accessCamera) && props.accessCamera;

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.accessCamera();
      });
    }
  });

  _defineProperty(this, "setActiveCamera", function (prevProps, props) {
    var shouldSet = (prevProps == null || prevProps.camera != props.camera) && props.camera != null && _this.picker.getActiveCamera() != props.camera;

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.setActiveCamera(props.camera);
      });
    }
  });

  _defineProperty(this, "setCameraSettings", function (prevProps, props) {
    var shouldSet = prevProps == null || JSON.stringify(prevProps.cameraSettings) != JSON.stringify(props.cameraSettings);

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.applyCameraSettings(props.cameraSettings);
      });
    }
  });

  _defineProperty(this, "setEnableCameraSwitcher", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enableCameraSwitcher != props.enableCameraSwitcher;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setCameraSwitcherEnabled(props.enableCameraSwitcher));
      });
    }
  });

  _defineProperty(this, "setEnableTorchToggle", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enableTorchToggle != props.enableTorchToggle;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setTorchToggleEnabled(props.enableTorchToggle));
      });
    }
  });

  _defineProperty(this, "setEnablePinchToZoom", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enablePinchToZoom != props.enablePinchToZoom;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setPinchToZoomEnabled(props.enablePinchToZoom));
      });
    }
  });

  _defineProperty(this, "setEnableTapToFocus", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enableTapToFocus != props.enableTapToFocus;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setTapToFocusEnabled(props.enableTapToFocus));
      });
    }
  });

  _defineProperty(this, "setGuiStyle", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.guiStyle != props.guiStyle;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setGuiStyle(props.guiStyle));
      });
    }
  });

  _defineProperty(this, "setLaserArea", function (prevProps, props) {
    var shouldSet = prevProps == null || JSON.stringify(prevProps.laserArea) != JSON.stringify(props.laserArea);

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setLaserArea(props.laserArea));
      });
    }
  });

  _defineProperty(this, "setMirrorImage", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.mirrorImage != props.mirrorImage;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setMirrorImageEnabled(props.mirrorImage));
      });
    }
  });

  _defineProperty(this, "setPlaySoundOnScanEnabled", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.playSoundOnScan != props.playSoundOnScan;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setPlaySoundOnScanEnabled(props.playSoundOnScan));
      });
    }
  });

  _defineProperty(this, "setVibrateOnScanEnabled", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.vibrateOnScan != props.vibrateOnScan;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setVibrateOnScanEnabled(props.vibrateOnScan));
      });
    }
  });

  _defineProperty(this, "setTargetScanningFPS", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.targetScanningFPS != props.targetScanningFPS;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setTargetScanningFPS(props.targetScanningFPS));
      });
    }
  });

  _defineProperty(this, "setVideoFit", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.videoFit != props.videoFit;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setVideoFit(props.videoFit));
      });
    }
  });

  _defineProperty(this, "setVisible", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.visible != props.visible;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setVisible(props.visible));
      });
    }
  });

  _defineProperty(this, "setViewfinderArea", function (prevProps, props) {
    var shouldSet = prevProps == null || JSON.stringify(prevProps.viewfinderArea) != JSON.stringify(props.viewfinderArea);

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setViewfinderArea(props.viewfinderArea));
      });
    }
  });

  _defineProperty(this, "setZoom", function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.zoom != props.zoom;

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.setZoom(props.zoom);
      });
    }
  });
};

export { _default as default };